<template>
    <div class="section hero">
        <div class="container">
            <div class="content">
                <h1 class="white-text center-text">Find Your Perfect Sleep Cycle</h1>
                <h4 class="light-text center-text">A traditional sleep cycle isn’t for everyone.</h4>
                <h4 class="light-text center-text">Let us help you find your optimal one, so you can make the most out of your days.</h4>
                <div class="interaction">
                    <button v-scroll-to="'#list'" class="btn">
                        <p class="large-body accent-text">Learn More</p>
                    </button>
                </div>
            </div>
        </div>

        <div class="bg-container">
            <div class="bg-layers">
                <div class="clouds-container">
                    <div class="cloud-wrapper">
                        <div class="cloud big-cloud-1"></div>
                        <div class="cloud small-cloud-1"></div>
                    </div>
                </div>
                <div class="clouds-container">
                    <div class="cloud-wrapper">
                        <div class="cloud big-cloud-2"></div>
                        <div class="cloud small-cloud-2"></div>
                    </div>
                </div>

                <div class="stars-container">
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                </div>

                <div class="moon-container">
                    <div class="moon moon-1"></div>
                    <div class="moon moon-2"></div>
                    <div class="moon moon-3"></div>
                </div>
            
                <div class="landscape-bg">
                    <img src="@/assets/homeHero/tree-layer.png" alt="Tree-Layer" class="tree-layer">
                    <img src="@/assets/homeHero/hills-layer.png" alt="Hill-Layer" class="hill-layer">
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: "Hero",

  methods: {
    pageLink: function() {
      location.href = "#list";
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/global.scss";

.hero {
  position: relative;
  background-color: $dark-shade-2;
  height: 100vh;
  align-items: center;
}

.hero .content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero h1 {
  margin-bottom: 40px;
  @media only screen and (max-width: $tablet) {
    width: 90%;
  }
}

.hero h4 {
  margin-bottom: 20px;
  width: 64%;
  @media only screen and (max-width: $tablet) {
    width: 80%;
  }
}

.hero .btn {
  margin-top: 50px;
}

.hero .container {
  z-index: 5;
}

.hero .bg-container {
  position: absolute;
  height: inherit;
  width: 100%;
  overflow: hidden;
}

// .hero .landscape-bg {
//     height: 100vh;
// }

.hero .tree-layer {
  z-index: 1;
  position: absolute;
  object-fit: cover;
  object-position: center;
  height: 100vh;
  width: 100%;
}

.hero .hill-layer {
  position: absolute;
  object-fit: cover;
  object-position: center;
  // height: 100vh;
  width: 100%;
  height: 310px;
  bottom: 0;
}

.bg-layers .moon-container {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 7%;
  margin-top: 5%;
}

.bg-layers .moon {
  position: relative;
  background-color: #f8f5ff;
  border-radius: 100%;
}

.bg-layers .moon-1 {
  height: 80px;
  width: 80px;
  background: rgb(160, 153, 189);
  background: -moz-radial-gradient(
    circle at bottom right,
    rgba(160, 153, 189, 1) 0%,
    rgba(248, 245, 255, 1) 100%
  );
  background: -webkit-radial-gradient(
    circle at bottom right,
    rgba(160, 153, 189, 1) 0%,
    rgba(248, 245, 255, 1) 100%
  );
  background: radial-gradient(
    circle at bottom right,
    rgba(160, 153, 189, 1) 0%,
    rgba(248, 245, 255, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a099bd",endColorstr="#f8f5ff",GradientType=1);
}

.bg-layers .moon-2 {
  margin-top: -90px;
  margin-left: -10px;
  height: 100px;
  width: 100px;
  opacity: 0.05;

  background: rgb(248, 245, 255);
  background: -moz-radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0.6334733722590599) 100%
  );
  background: -webkit-radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0.6334733722590599) 100%
  );
  background: radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0.6334733722590599) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f8f5ff",endColorstr="#f8f5ff",GradientType=1);
}

.bg-layers .moon-3 {
  margin-top: -150px;
  margin-left: -60px;
  height: 200px;
  width: 200px;
  opacity: 0.01;
  background: rgb(248, 245, 255);
  background: -moz-radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0) 100%
  );
  background: -webkit-radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0) 100%
  );
  background: radial-gradient(
    circle,
    rgba(248, 245, 255, 1) 0%,
    rgba(248, 245, 255, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f8f5ff",endColorstr="#f8f5ff",GradientType=1);

  //animation
  animation-name: moon-bg;
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@keyframes moon-bg {
  from {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
  to {
    transform: scale(1);
  }
}

// .bg-layers .stars-container {

// }

.bg-layers .star {
  right: 50%;
  top: 50%;
  position: absolute;
  background-color: #f8f5ff;
  border-radius: 100%;
  opacity: 0.75;
  width: 3px;
  height: 3px;
  -webkit-clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );

  //animation
  animation-name: stars;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}

@keyframes stars {
  from {
    transform: scale(1);
  }
  2% {
    transform: scale(1.4);
  }
  4% {
    transform: scale(1);
  }
  to {
    transform: scale(1);
  }
}

.star:nth-child(1) {
  top: 0;
  margin-top: 40px;
  margin-right: -20px;
  animation-delay: 1s;
}

.star:nth-child(2) {
  bottom: 0;
  margin-top: 100px;
  margin-right: -225px;
  animation-delay: 2s;
}

.star:nth-child(3) {
  margin-top: -100px;
  margin-right: -470px;
  animation-delay: 3s;
}

.star:nth-child(4) {
  margin-top: -140px;
  margin-right: 470px;
  animation-delay: 4s;
}

.star:nth-child(5) {
  margin-top: 70px;
  margin-right: 370px;
  animation-delay: 5s;
}

.star:nth-child(6) {
  margin-top: -325px;
  margin-right: 125px;
  animation-delay: 1.5s;
}

.star:nth-child(7) {
  margin-top: -295px;
  margin-right: -275px;
  animation-delay: 2.5s;
}

.star:nth-child(8) {
  margin-top: -195px;
  margin-right: -75px;
  animation-delay: 3.5s;
}

.star:nth-child(9) {
  margin-top: -105px;
  margin-right: 75px;
  animation-delay: 4.5s;
}

.star:nth-child(10) {
  margin-top: -60px;
  margin-right: -285px;
  animation-delay: 0.5s;
}

.clouds-container {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.1;
  z-index: 10;

  //animation
  animation-name: clouds;
  animation-duration: 20s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@keyframes clouds {
  from {
    transform: translate(0, 0px);
  }
  50% {
    transform: translate(-80px, 0px);
  }
  to {
    transform: translate(0px, 0px);
  }
}

.clouds-container:nth-child(1) {
  margin-right: 165px;
  margin-top: 70px;
}

.clouds-container:nth-child(2) {
  margin-right: 605px;
  margin-top: 25px;
  animation-delay: 4s;
}

.clouds-container .big-cloud-1 {
  height: 175px;
  width: 175px;
  background: black;
  right: 0;
  border-radius: 100%;
}

.clouds-container .small-cloud-1 {
  height: 100px;
  width: 100px;
  background: black;
  right: 0;
  margin-top: -105px;
  margin-left: -55px;
  border-radius: 100%;
}

.clouds-container .big-cloud-2 {
  height: 100px;
  width: 100px;
  background: black;
  right: 0;
  border-radius: 100%;
}

.clouds-container .small-cloud-2 {
  height: 70px;
  width: 70px;
  background: black;
  right: 0;
  margin-top: -75px;
  margin-left: 75px;
  border-radius: 100%;
}
</style>
